import styled from 'styled-components';
import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
import { LightGreyBox } from '../../styled';
export const OrderSummaryContainer = styled.div `
  border: 1px solid ${COLORS.darkOrange};
  border-radius: 4px;
  color: ${COLORS.grayBlack};
  margin-bottom: 15px;
  s-col {
    padding-bottom: 0;
    min-width: auto !important;
  }
  .order-summary {
    background-color: ${COLORS.darkOrange};
    border-radius: 3px 3px 0 0;
    padding-left: 0.75rem;
    span, s-icon {
      font-size: 21px;
      line-height: 42px;
    }
  }

  @media only screen and (max-width: 383px) {
    s-col {
      padding: 0 20px;
    }
  }
  .order-summary-text {
    font-size: 16px;
  }

  .smaller-text {
    font-size: smaller;
  }

  .small-text {
    font-size: small;
  }

  .small-height {
    line-height: 12px;
  }

  .inherit-text {
    *:not(h1, h2, h3, h4, h5) {
      font-size: inherit;
    }
  }
`;
export const BlueOrderSummaryContainer = styled(OrderSummaryContainer) `
  border-color: ${COLORS.darkBlue}
  .order-summary {
    background-color: ${COLORS.darkBlue}
  }
`;
export const OrangeHorizontalRule = styled.hr `
  margin: 0px auto;
  border: 1px solid ${COLORS.darkOrange};
`;
export const GreyTermsBox = styled(LightGreyBox) `
  border-radius: 0 0 3px 3px;
  padding: 0.5rem 1rem;
  width: 100%;
  s-col {
    padding: 0px;
  }
  s-row {
    align-items: center;
  }
`;
export const OrangeBorderTermsBox = styled(GreyTermsBox) `
  border-top: 1px solid ${COLORS.darkOrange};
`;
